import { useState, useEffect } from 'react';

export const useLockedSoftAlert = isLocked => {
  const [showLockedSoftAlert, setShowLockedSoftAlert] = useState(false);

  function closeLockedSoftAlert() {
    setShowLockedSoftAlert(false);
  }

  useEffect(() => {
    setShowLockedSoftAlert(isLocked);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLocked]);

  return {
    showLockedSoftAlert,
    closeLockedSoftAlert
  };
};
